import React, {FC, useEffect, useState} from 'react'

import {observer} from 'mobx-react-lite'

import PayStubItemStore from 'models/PayStub/PayStubItem.store'
import {usePayStubStore} from 'src/utils/contexts/RootStore.context'
import useDebounce from 'src/utils/hooks/useDebounce'

import ItemEarning from './ItemEarning'

interface IItemEarningsListProps {
	store: PayStubItemStore
	topCancel: () => void
}

const ItemEarningsList: FC<IItemEarningsListProps> = ({store: item, topCancel}) => {
	const payStubStore = usePayStubStore()
	const {paymentType, employmentType} = payStubStore
	/** specifies if we need to trigger recalculation after debounce */
	const [calculateCount, setCalculateCount] = useState(0)
	/** specifies if we need to recalculate after the last blur event */
	const [shouldCalculate, setShouldCalculate] = useState(false)

	const handleCalculation = () => {
		item.calculate()
		setShouldCalculate(false)
	}

	const [, cancel] = useDebounce(handleCalculation, 100, [calculateCount])
	// Calculate canceling to avoid duplication of requests
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => cancel(), [])

	const allEarnings = [...Object.values(item.earnings), ...item.customEarnings]

	return (
		<>
			{allEarnings.map((earningItem) => {
				if (!earningItem) return null
				const {id} = earningItem

				if (paymentType !== 'salary' && earningItem.key === 'salary') return null
				if (paymentType !== 'hourly' && earningItem.key === 'regular') return null
				if (employmentType === 'employee' && earningItem.key === 'contractor') return null
				if (employmentType === 'contractor' && earningItem.key === 'regular') return null

				return (
					<ItemEarning
						key={id}
						store={earningItem}
						setCalculateCount={setCalculateCount}
						setShouldCalculate={setShouldCalculate}
						shouldCalculate={shouldCalculate}
						cancel={() => {
							cancel()
							topCancel()
						}}
					/>
				)
			})}
		</>
	)
}

ItemEarningsList.displayName = 'ItemEarningsList'

export default observer(ItemEarningsList)
